import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const customFontSize = '14px';

const rowStyle = {
  fontSize: customFontSize,
  color: colors.black,
  fontWeight: fonts.weights.normal,
  letterSpacing: '0.25px',
  lineHeight: '20px',
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '15px',
  },
  summary: {
    backgroundColor: colors.planningGridAccordionSumaryBg,
    minHeight: '72px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  buttonsActionsContainer: {
    display: 'flex',
    width: '100%',
    minHeight: '52px',

    '& .MuiButton-text': {
      fontSize: customFontSize,
      fontWeight: fonts.weights['extra-bold'],
      letterSpacing: '1.25px',
      lineHeight: '16px',
    },
  },
  container: {
    background: colors.white,
    width: '100%',
    marginTop: '10px',

    '& .MuiTable-root': {
      borderCollapse: 'collapse',
    },
    // Table root
    '& > div:first-child': {
      height: '385px',
      paddingBottom: '16px',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      background: '#fff',
      zIndex: 999,
      boxShadow:
        'inset 0 1px 0 1px solid rgba(224, 224, 224, 1), inset 0 -1px 0 1px solid rgba(224, 224, 224, 1)',
    },
    // Table container
    '& > div:first-child > div': {
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    '& .MuiTableCell-root': {
      ...rowStyle,
      maxHeight: '64px',
      wordWrap: 'break-word',
    },
    '& .Mui-checked': {
      color: colors.primary,
    },
  },
  buttonsActionsContainerRight: {
    justifyContent: 'flex-end',
    display: 'flex',
    width: '100%',
  },
  selectedRows: {
    backgroundColor: colors.primary02,
    borderLeft: `1px solid ${colors.primary}`,
  },
  tableTitle: {
    fontSize: customFontSize,
    color: colors.black,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  tooltipLabel: {
    ...rowStyle,
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  iconButtonContainer: {
    padding: 0,
  },
  scrollDiv: {
    width: '100%',
    overflowX: 'auto',
  },
  hiddenScrollDiv: {
    height: '1px',
  },
  iconButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default useStyles;
